<div class="efile-setup-container">
  <!--
    Legacy parity: each of the three sub-states
    (`enabledDisabled`, `unlockValidation`, `formElementsReport`) has its
    own sidebar entry and renders a single grid (see
    `ui/app/components/efile/efileElements/enabled-disabled.html` etc.).
    Hide the tab strip when an `initialTab` is supplied so the deep-linked
    screen looks like the legacy single-grid view.
  -->
  @if (!initialTab) {
<ul class="nav nav-tabs" role="tablist">
    @for (tab of tabs; track $index) {
<li class="nav-item">
      <a
        class="nav-link"
        [class.active]="isSelected(tab.key)"
        [attr.aria-current]="isSelected(tab.key) ? 'page' : null"
        tabindex="0"
        role="tab"
        (click)="selectTab(tab.key)"
        (keyup.enter)="selectTab(tab.key)"
      >
        {{ tab.label }}
      </a>
    </li>
}
  </ul>
}

  <div class="content-view">
    @if (hasActiveSubmission()) {

      @if (gridConfig) {
<div
       
        efileGrid
        #setupGrid="efileGrid"
        class="gizmo-grid"
        [gridConfig]="gridConfig"
        (gridCallback)="onGridCallback($event)"
      ></div>
}
    
} @else {

      <div class="tab-placeholder">
        <div class="tab-placeholder__hint">
          Select a submission from the Submissions list to load this grid.
        </div>
      </div>
    
}

    
  </div>
</div>

<!--
  Confirmation modal — mirrors the legacy
  `templates/modals/confirm-action.html` flow used by
  `EnabledDisabledController#enabledDisabledForm` and
  `UnlockValidationController#unlockValidationForm`. Uses the shared
  `gtw-confirmation-modal` so the look matches every other efile confirm.
-->
@if (showConfirm) {
<gtw-confirmation-modal
 
  [config]="confirmConfig"
  [visible]="false"
  (confirmed)="onConfirm()"
  (cancelled)="onCancelConfirm()"
  (closed)="onCancelConfirm()">
</gtw-confirmation-modal>
}
